import { Item } from "@radix-ui/react-accordion";
import type React from "react";

import { cn } from "@/lib/utils";

interface AccordionItemProps {
  className?: string;
  value: string;
  children: React.JSX.Element | React.JSX.Element[];
}

const AccordionItem = ({
  className = "",
  value,
  ...props
}: AccordionItemProps) => (
  <Item className={cn("border-b", className)} value={value} {...props} />
);

export { AccordionItem };
